import {Component, NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {IonicApp, IonicModule, IonicErrorHandler} from 'ionic-angular';
import {IonicStorageModule} from '@ionic/storage';

import {MyApp} from './app.component';

import {Http, JsonpModule, HttpModule} from '@angular/http';

import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {ComponentsModule} from '../components/components.module'

import {CoverageService} from '../services/coverage.service'
import {PostService} from '../services/post.service'

import { ToastService } from '../services/util/toast.service';

import { SeoService } from '../services/seo.service';



import { MultilevelMenuComponent } from '../components/multilevel-menu/multilevel-menu';
import { MenuService } from '../components/multilevel-menu/menu';


import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SuperTabsModule, SuperTabsController } from 'ionic2-super-tabs';

import { SnotifyModule, SnotifyService } from 'ng-snotify';

import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateService} from '@ngx-translate/core';

import { MasonryModule } from 'angular2-masonry';

import { AngularFireModule, } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { AngularFireStorage } from 'angularfire2/storage';
//import { AngularFireStorageModule } from 'angularfire2/storage';

import * as ionicGalleryModal from 'ionic-gallery-modal';
//import * as ionicGalleryModal from '../pages/gallery/index';

import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

//import { IonicImageViewerModule } from 'ionic-img-viewer';

//import { MomentModule } from 'angular2-moment';
import { PopoverPage as PopoverContentPage } from '../pages/coverage/list/coverage.list';
import { SelectLangPage as PopoverSelectPage } from '../app/app.component';







import { IonicImageViewerModule } from '../pages/zoom/module';



//import {NgxChartsModule} from '@swimlane/ngx-charts';


export const firebaseConfig = {
  apiKey: "AIzaSyBii-6p9L7shJDy9vpce0a6SjitR6faVN0",
  authDomain: "aware-dev-ed28f.firebaseapp.com",
  databaseURL: "https://aware-dev-ed28f.firebaseio.com",
  projectId: "aware-dev-ed28f",
  storageBucket: "aware-dev-ed28f.appspot.com",
  messagingSenderId: "70381501049"
};

export const firebaseConfigCDM = {
  apiKey: "AIzaSyBx0l-pemEWekTp0xGUBO1dlrQDbLKs0JU",
  authDomain: "cdm-2018-f941f.firebaseapp.com",
  databaseURL: "https://cdm-2018-f941f.firebaseio.com",
  projectId: "cdm-2018-f941f",
  storageBucket: "cdm-2018-f941f.appspot.com",
  messagingSenderId: "832080279207"
};

const MyOption =  {
  backButtonText: '',
  iconMode: 'md',
  //modalEnter: 'modal-md-slide-in',
  //modalLeave: 'modal-md-slide-out',
  tabbarPlacement: 'bottom',
  mode: 'md',
  pageTransition: 'ios-transition',
  backButtonIcon: 'ios-arrow-back',

  popoverEnter: 'popover-pop-in',
  popoverLeave: 'popover-pop-out',

  preloadModules: true,
  platforms: {
    ios: {
      statusbarPadding: false,
    }
  },
  //tabSubPages: true
}

export function createTranslateLoader(http: Http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyApp, MultilevelMenuComponent, PopoverContentPage, PopoverSelectPage
  ],
  imports: [
    BrowserModule,BrowserAnimationsModule,
    HttpModule,
    IonicModule.forRoot(MyApp, MyOption),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFirestoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),

    IonicImageViewerModule,
    
    IonicStorageModule.forRoot({
      name: '__eclectic',
      //driverOrder: ['indexeddb']
    }),
    JsonpModule,
    SnotifyModule,
    
    ionicGalleryModal.GalleryModalModule,
		//IonicImageViewerModule
    
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp, MultilevelMenuComponent, PopoverContentPage, PopoverSelectPage
  ],
  providers: [
    AngularFireDatabase, AngularFireStorage, 
    CoverageService, 
    PostService, 
    TranslateService, 
    MenuService, 
    SuperTabsController, 
    SnotifyService,
    ToastService,
    SeoService,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: ionicGalleryModal.GalleryModalHammerConfig,
    }
    
  ],//{provide: ErrorHandler, useClass: IonicErrorHandler} Geolocation, SplashScreen, StatusBar, 
  schemas:     [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts